import { useCallback, useMemo } from "react";
import { MUTATIONS, QUERIES } from "..";
import { useSnackbarLazyQuery, useSnackbarMutation } from "../../hooks";
import { ServiceTypeListItem, ServiceTypeListItemType } from "../models";

export function useServiceListItems() {
  const [fetchServiceListItems, { 
    loading: fetchServiceListItemsLoading, 
    error: fetchServiceListItemsError,
    data: fetchServiceListItemsData,
    refetch
  }] = useSnackbarLazyQuery(
    QUERIES.SERVICE_TYPE_LIST_ITEMS, {
      fetchPolicy: 'no-cache',
      nextFetchPolicy: 'no-cache'
    }
  );

  const serviceListItems: ServiceTypeListItem[] = useMemo(() => {
    return fetchServiceListItemsData && fetchServiceListItemsData.serviceTypeListItems;
  }, [fetchServiceListItemsData]);

  const [invokeUpdateListItem, {
    loading: invokeUpdateListItemLoading,
    error: invokeUpdateListItemError
  }] = useSnackbarMutation(
    MUTATIONS.UPDATE_SERVICE_TYPE_LIST_ITEM
  );

  const fetchServiceItems = useCallback(() => {
    fetchServiceListItems({
      variables: {
        type: ServiceTypeListItemType.SERVICE
      }
    });
  }, [fetchServiceListItems]);

  const fetchProductItems = useCallback(() => {
    fetchServiceListItems({
      variables: {
        type: ServiceTypeListItemType.PRODUCT
      }
    });
  }, [fetchServiceListItems]);

  return { 
    fetch: fetchServiceListItems, refetch, fetchServiceListItemsLoading, fetchServiceListItemsData,
    fetchServiceListItemsError, serviceListItems,
    invokeUpdateListItem, invokeUpdateListItemLoading,
    invokeUpdateListItemError,
    fetchServiceItems, fetchProductItems
  };
}